import React from 'react'

import { VideoProps } from '/lib/modules/video/index.d';

import VideoBlock from '/react4xp/components/VideoBlock'

function VideoPart(props: VideoProps) {
    return <VideoBlock {...props} />
}

export default (props) => <VideoPart {...props} />
